import { render } from "./table-cell-text.vue?vue&type=template&id=d9d72b28"
import script from "./table-cell-text.vue?vue&type=script&lang=js"
export * from "./table-cell-text.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__